module.exports = __webpack_public_path__ + "img/6_116.5f6980a3.png";